<template>
  <div>
    <CustomTable 
      :first-cell-image="true" 
      :custom-class="'ap-players-table double-image'">
      <template slot="theader">
        <TableRow>
          <TableCell :class="{'fixed-column first-col':scrollLeftOver25}">
            <div class="gear-btn-wrapper gear-stats">
              <b-btn :id="'metricInfoPopover_ApStatsTable'" :class="'popover-btn'">
                <img src="@/assets/images/icons/gear-icon.png" alt="unit settings icon" />
              </b-btn>

              <div class="custom-popover table-settings-popover" id="popoverPlacement_ApStatsTable"></div>

              <b-popover 
                :target="'metricInfoPopover_ApStatsTable'" 
                triggers="click blur" 
                placement="bottomright"
                container="popoverPlacement_ApStatsTable">

                <div class="popover-content">
                  <div class="table-setting-row">
                    <div class="row-content">
                      <div class="row-content-item">
                        <span class="row-label">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.ap')}}</span>
                        <div 
                          class="btn-group calendar-view-filter switch-btn-group switch-btn-group-orange fa-pull-right" 
                          @click="changeApUnitOnClick">
                          <label class="btn" 
                            :class="{'active': apZonesSelectedUnit == apZonesUnits.PERCENTAGE}">%</label>
                          <label class="btn" 
                            :class="{'active': apZonesSelectedUnit == apZonesUnits.TIME_IN_MINUTES_SECONDS}">mm:ss</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-popover>
            </div>
            
           <span :class="{'d-none':scrollLeftOver25}">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.player')}}</span>
          </TableCell>
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.ap')}}</TableCell>
          <TableCell :custom-classes="'purple-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.low')}}</TableCell>
          <TableCell :custom-classes="'yellow-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.moderate')}}</TableCell>
          <TableCell :custom-classes="'red-column'">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.vigorous')}}</TableCell>
          <TableCell>{{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.calories')}}
              <img src="@/assets/images/common/info-btn.png" alt="help icon" class="help-icon" id="ap-calories-tooltip">
              <b-tooltip target="ap-calories-tooltip" triggers="hover focus" placement="top">
                {{ $t('SESSION_HISTORY.table.tooltipCalories')}}
              </b-tooltip>
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>

    <CustomTable 
      :first-cell-image="true"
      :custom-class="'accordion-table view-players-table ap-players-table double-image'">
      <template slot="tbody">
        <TableRow>
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <span class="battery-warnings" v-if="!scrollLeftOver25 && activityInfo.batteryLevelIsLow" v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.batteryWarningsTooltip') ,
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }">
              <img src="@/assets/images/activity/10_battery.png" alt="battery warning">
            </span>

            <span 
              v-if="!scrollLeftOver25 && activityInfo.sensorError"
              v-b-tooltip="{
                title: this.$t('CALENDAR_ACTIVITY.playerStatsTables.sensorError'),
                container: 'body',
                boundary: 'viewport',
                trigger: 'hover',
                template: tooltipTemplate,
                placement: 'topright'
              }"
              class="other-img error-icon cursor-pointer text-error">
              <i class="fas fa-minus-circle" aria-hidden="true"></i>
            </span>

            <img class="player-icon cell-img" v-if="activityInfo.playerPhoto" :src="activityInfo.playerPhoto" alt="player photo" />
            <CustomEmblem 
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'"
              />
            
            <span :class="{'d-none':scrollLeftOver25}">
              {{ $t('CALENDAR_ACTIVITY.playerStatsTables.apStatsTable.fullSession')}} ({{activityInfo.durationInSeconds | secondsToMinutesSeconds}})
            </span>
          </TableCell>
            <!-- Avg AP -->
          <TableCell>
            <template v-if="data.invalid">
              {{ $t('COMMON.notApplicable')}}
            </template>
            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ data.avgAPPercentage != null ? `${data.avgAPPercentage}%` : $t('COMMON.notApplicable') }}
            </template>
            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="data.avgAPSeconds != null && !data.invalid">{{ (data.avgAPSeconds) | secondsToMinutesSeconds }}</template>
              <template v-if="data.avgAPSeconds === null && !data.invalid">{{ $t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
            <!-- End of Avg AP -->
          <TableCell :custom-classes="'purple-column'">
            <template v-if="data.invalid">
              {{ $t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ data.apZoneLPercentage != null ? `${data.apZoneLPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="data.apZoneLSeconds != null && !data.invalid">{{ (data.apZoneLSeconds) | secondsToMinutesSeconds }}</template>
              <template v-if="data.apZoneLSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell :custom-classes="'yellow-column'">
            <template v-if="data.invalid">
              {{ $t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ data.apZoneMPercentage != null ? `${data.apZoneMPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="data.apZoneMSeconds != null && !data.invalid">{{ (data.apZoneMSeconds) | secondsToMinutesSeconds}}</template>
              <template v-if="data.apZoneMSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">
              {{ $t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ data.apZoneVPercentage != null ? `${data.apZoneVPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="data.apZoneVSeconds != null && !data.invalid">{{ (data.apZoneVSeconds) | secondsToMinutesSeconds}}</template>
              <template v-if="data.apZoneVSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell>
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="data.avgKiloCalories === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <template v-if="data.avgKiloCalories != null && !data.invalid">{{data.avgKiloCalories}}</template>
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>

    <CustomTable 
      v-for="segment in statsSegment"
      :key="segment.id"
      :first-cell-image="true"
      :custom-class="'accordion-table view-players-table ap-players-table double-image'">
      <template slot="tbody">
        <TableRow>
          <TableCell :class="{'fixed-column data-col':scrollLeftOver25}">
            <PlayerInvalidActivityIcon :activity-status="activityInfo.status" />

            <img class="player-icon cell-img" v-if="activityInfo.playerPhoto" :src="activityInfo.playerPhoto" alt="player photo" />
            <CustomEmblem 
              v-if="!activityInfo.playerPhoto"
              :gender="activityInfo.playerGender"
              :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]"
              :custom-classes="'cell-img'" 
              />
            <span :class="{'d-none':scrollLeftOver25}">
              {{segment.name}} ({{(segment.endPoint - segment.startPoint) | secondsToMinutesSeconds}})
            </span>
          </TableCell>
          <!-- Avg AP -->
          <TableCell>
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>
            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ segment.segmentStats.avgAPPercentage != null ? `${segment.segmentStats.avgAPPercentage}%` : $t('COMMON.notApplicable') }}
            </template>
            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="segment.segmentStats.avgAPSeconds != null && !data.invalid">{{ (segment.segmentStats.avgAPSeconds) | secondsToMinutesSeconds }}</template>
              <template v-if="segment.segmentStats.avgAPSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <!-- End of Avg AP -->
          <TableCell :custom-classes="'purple-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ segment.segmentStats.apZoneLPercentage != null ? `${segment.segmentStats.apZoneLPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="segment.segmentStats.apZoneLSeconds != null && !data.invalid">{{ (segment.segmentStats.apZoneLSeconds) | secondsToMinutesSeconds}}</template>
              <template v-if="segment.segmentStats.apZoneLSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell :custom-classes="'yellow-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ segment.segmentStats.apZoneMPercentage != null ? `${segment.segmentStats.apZoneMPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="segment.segmentStats.apZoneMSeconds != null && !data.invalid">{{ (segment.segmentStats.apZoneMSeconds) | secondsToMinutesSeconds}}</template>
              <template v-if="segment.segmentStats.apZoneMSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell :custom-classes="'red-column'">
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.PERCENTAGE && !data.invalid">
              {{ segment.segmentStats.apZoneVPercentage != null ? `${segment.segmentStats.apZoneVPercentage}%` : $t('COMMON.notApplicable') }}
            </template>

            <template v-if="apZonesSelectedUnit === apZonesUnits.TIME_IN_MINUTES_SECONDS && !data.invalid">
              <template v-if="segment.segmentStats.apZoneVSeconds != null && !data.invalid">{{ (segment.segmentStats.apZoneVSeconds) | secondsToMinutesSeconds}}</template>
              <template v-if="segment.segmentStats.apZoneVSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            </template>
          </TableCell>
          <TableCell>
            <template v-if="data.invalid">
              {{$t('COMMON.notApplicable')}}
            </template>

            <template v-if="segment.segmentStats.avgKiloCalories === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
            <template v-if="segment.segmentStats.avgKiloCalories != null && !data.invalid">{{segment.segmentStats.avgKiloCalories}}</template>
          </TableCell>
        </TableRow>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { CustomTable, TableRow, TableCell } from '@/components/common/table'
import CustomEmblem from '@/components/common/CustomEmblem'
import { AP_ZONES_UNITS } from '@/constants/SessionConsts'
import PlayerInvalidActivityIcon from '@/components/calendar-activity/PlayerInvalidActivityIcon'

export default {
  name: 'ActiveParticipationStatsTable',
  props: {
    data : Object,
    activityInfo : Object,
    apZonesSelectedUnit : String,
    changeApZonesUnit: Function,
    statsSegment: Array,
    scrollLeftOver25 : Boolean
  },
  
  data () {
    return {
      apZonesUnits: AP_ZONES_UNITS,
      tooltipTemplate: '<div class="tooltip event-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'

    }
  },
  methods: {
    changeApUnitOnClick () {
      const newApUnit = this.apZonesSelectedUnit === this.apZonesUnits.PERCENTAGE ? this.apZonesUnits.TIME_IN_MINUTES_SECONDS : this.apZonesUnits.PERCENTAGE
      
      this.changeApZonesUnit(newApUnit)
    }
  },
  components: {
    CustomTable,
    TableRow,
    TableCell,
    CustomEmblem,
    PlayerInvalidActivityIcon
  }
}
</script>

<style lang="scss" scoped>
  .ap-players-table {
    table-layout: fixed;

    .table-cell {
      &:first-child {
        width: 30%;
      }

      &:nth-child(n+2) {
        width: 15%;
      }

      
      .help-icon {
        width: 20px;
        height: 20px;
        margin-left: 3px;
        margin-bottom: 2px;
        cursor: default;
      }
    }
  }
</style>


